import { FaPlus } from 'react-icons/fa'
import ListLayout from '../../../components/layout/main/ListLayout'
import Text from '../../../core/utils/Text'
import { useState } from 'react'
import {
	useGetAccountingConfig,
	useSetAccountingConfig,
} from '../../../core/services/react-query/setting/accounting'
import AccountingCard from '../../../components/main/setting/accounting/AccountingCard'
import ModalLayout from '../../../components/layout/main/ModalLayout'
import BasicModal from '../../../components/modals/BasicModal'
import AccountingModal from '../../../components/main/setting/accounting/AccountingModal'
import { deepCopy } from '../../../core/utils/common'

const Accounting = () => {
	const { data: onboard } = useGetAccountingConfig()

	// add modal
	const initialAdd = { data: null, open: false, idx: -1, type: null }
	const [addModal, setAddModal] = useState(initialAdd)
	const openAddModal = (data, idx, type) => setAddModal({ data, open: true, idx, type })
	const closeAddModal = () => setAddModal(initialAdd)

	// remove modal
	const removeInitial = { show: false, data: null, idx: -1, type: null }
	const [removeModal, setRemoveModal] = useState(removeInitial)
	const closeRemoveModal = () => setRemoveModal(removeInitial)
	const openRemoveModal = (data, idx, type) => setRemoveModal({ data, idx, show: true, type })

	const { mutate: mutateConfigs, isLoading } = useSetAccountingConfig(() => {
		closeAddModal()
		closeRemoveModal()
	})

	const onRemove = () => {
		const newAccountings = deepCopy(onboard)
		newAccountings[removeModal.type].splice(removeModal.idx, 1)
		mutateConfigs(newAccountings)
	}

	return (
		<ListLayout>
			<div className={'w-full flex flex-col gap-5 dark:text-gray-300'}>
				<div className={'rounded-md w-full h-[58px] dark:bg-cardBg bg-gray-100'}>
					<div className={'flex items-center h-full px-8 justify-between gap-2'}>
						<Text tid={'manual-accounting-deposit'} />
						<div
							className={`rounded-md bg-active cursor-pointer text-gray-700 py-2 px-3 flex items-center gap-2
                            `}
							onClick={() => openAddModal(null, -1, 'deposit')}
						>
							<FaPlus size={16} />
							<Text tid={'add-accounting'} className={'text-sm'} />
						</div>
					</div>
				</div>
				<div className={'flex flex-wrap gap-3'}>
					{onboard?.deposit?.map((item, idx) => {
						return (
							<div key={item.id}>
								<AccountingCard
									item={item}
									idx={idx}
									onEdit={openAddModal}
									onRemove={openRemoveModal}
									type={'deposit'}
								/>
							</div>
						)
					})}
				</div>
				<div className={'rounded-md w-full h-[58px] dark:bg-cardBg bg-gray-100'}>
					<div className={'flex items-center h-full px-8 justify-between gap-2'}>
						<Text tid={'manual-accounting-withdraw'} />
						<div
							className={`rounded-md bg-active cursor-pointer text-gray-700 py-2 px-3 flex items-center gap-2
                            `}
							onClick={() => openAddModal(null, -1, 'withdraw')}
						>
							<FaPlus size={16} />
							<Text tid={'add-accounting'} className={'text-sm'} />
						</div>
					</div>
				</div>
				<div className={'flex flex-wrap gap-3'}>
					{onboard?.withdraw?.map((item, idx) => {
						return (
							<div key={item.id}>
								<AccountingCard
									item={item}
									idx={idx}
									onEdit={openAddModal}
									onRemove={openRemoveModal}
									type={'withdraw'}
								/>
							</div>
						)
					})}
				</div>
			</div>

			<ModalLayout onClose={closeRemoveModal} open={removeModal.show} width={'580px'}>
				<BasicModal loading={isLoading} onSubmit={onRemove} onClose={closeRemoveModal} />
			</ModalLayout>

			<AccountingModal
				details={addModal}
				onClose={closeAddModal}
				mutate={mutateConfigs}
				cache={onboard}
				loading={isLoading}
			/>
		</ListLayout>
	)
}

export default Accounting
